import { CustomerKycStatus } from "@/types/customer.dto";

export const kycStatusMeta: Record<
  CustomerKycStatus,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline"; description: string }
> = {
  [CustomerKycStatus.NotSubmitted]: {
    label: "Not submitted",
    variant: "secondary",
    description: "Complete your KYC to unlock Member ID activation.",
  },
  [CustomerKycStatus.Submitted]: {
    label: "Under review",
    variant: "outline",
    description: "We're verifying your documents. This usually takes 1–2 business days.",
  },
  [CustomerKycStatus.Verified]: {
    label: "Verified",
    variant: "default",
    description: "Your identity is verified. You can activate your Member ID.",
  },
  [CustomerKycStatus.Rejected]: {
    label: "Rejected",
    variant: "destructive",
    description: "Please update your details and resubmit KYC.",
  },
};

export function getInitials(name: string): string {
  return (
    name
      .trim()
      .split(/\s+/)
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "U"
  );
}

export function splitName(fullName: string): { firstName: string; lastName?: string } {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return { firstName: "" };
  if (parts.length === 1) return { firstName: parts[0] };
  return { firstName: parts[0], lastName: parts.slice(1).join(" ") };
}
